module.exports = __webpack_public_path__ + "img/mq1.8e8ae003.png";